"use client";
import Image from "next/image";
import HomeLine from "../../../public/assets/images/home_line.png";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    scrollToAppointment: () => void;
  }
}

interface BookAppointmentProps {
  data: {
    id: string;
    title: string;
    subtitle: string;
    calLink: string;
    useH1Tag?: boolean;
  };
}

export default function BookAppointment({ data }: BookAppointmentProps) {
  const appointmentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    window.scrollToAppointment = () => {
      if (appointmentRef.current) {
        appointmentRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };
  }, []);

  return (
    <div
      ref={appointmentRef}
      className="flex flex-col items-center justify-center w-full min-h-screen bg-th-bg-col-rich px-8 py-12 box-border"
    >
      <div className="mb-[2px] md:mb-[8px]">
        {
          data?.useH1Tag ? (
            <h1 className="text-center mt-[5px] 2xl:text-[35px] xl:text-[33px] lg:text-[30px] md:text-[26px] sm:text-[24px] text-[22px] mb-0">
              {data.title}
            </h1>
          ) : (
            <h2 className="text-center mt-[5px] 2xl:text-[35px] xl:text-[33px] lg:text-[30px] md:text-[26px] sm:text-[24px] text-[22px] font-bold mb-0">
              {data.title}
            </h2>
          )
        }
        <div className="flex items-center justify-center mb-4">
          <Image
            src={HomeLine}
            alt="hero-shape"
            height={30}
            width={162}
            className="max-w-full h-auto "
          />
        </div>
      </div>
      <div className="relative w-full max-w-4xl rounded-lg shadow-sm overflow-hidden">
        <iframe
          src={data?.calLink || ""}
          className="w-full h-[800px] md:h-[750px] lg:h-[650px]"
          title="Goenka Jewellers Meeting Schedule"
        ></iframe>
      </div>
    </div>
  );
}
